<template>
  <div>
    <div class="cls-container" @click="clickOperate">
      <i v-if="close" id="el-icon-user" class="el-icon-user"></i>
      <i v-else="close" id="el-icon-close" class="el-icon-close"></i>
    </div>
    <AiPersonalOperate :visible="close"></AiPersonalOperate>
  </div>
</template>
<script>
  import AiPersonalOperate from './AI-Personal-Operate.vue'
  export default{
    name: 'AI-Personal-Center',
    components: {
      AiPersonalOperate,
    },
    data() {
      return {
        close: true,
      };
    },
    methods: {
      clickOperate() {
        this.close = !this.close
      }
    },
    mounted(){
      this.$bus.$on('updateClose', (visible)=>{this.close = visible})
    },
    beforeDestroy() {
      // 销毁创建AI刷新列表
      this.$bus.$off("updateClose");
    },
  }
</script>
<style lang="less" scoped>
.cls-container{
  position: absolute;
  width: 64px;
  height: 64px;
  top: 0px;
  right: 0px;
  background-color: #3459e2;
  border-left: 1px solid #fff;
  overflow: inherit;
  cursor: pointer;
}
.cls-container:hover{
  background-color: #0329b1;
}
#el-icon-user{
  font-size: 30px;
  color: #fff;
  margin: auto;  
  margin-top: 25%;
  margin-left: 25%;
}
#el-icon-close{
  font-size: 30px;
  color: #fff;
  margin: auto;  
  margin-top: 25%;
  margin-left: 25%;
}
</style>
